import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import "./styles.css";
import { carmenAuth, clearLegacySupabaseSession } from "./lib/carmenAuth";

function renderApp(rootElement: HTMLElement): void {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
}

function bootstrap(): void {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found — index.html is missing <div id='root'>");
  }

  // No mode probe: Carmen auth is the only path since the Supabase
  // decommission, so boot no longer waits on /api/auth/config.
  try {
    carmenAuth.startAutoRefresh();
    clearLegacySupabaseSession();
  } catch (err: unknown) {
    // Never leave a live user on a blank page over an auth-setup hiccup —
    // screens already handle a missing session by redirecting to /login.
    console.error("Auth bootstrap failed; rendering anyway.", err);
  }

  renderApp(rootElement);
}

bootstrap();
